import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import { Link, useHistory } from "react-router-dom";
import { UploadArea } from "../../../../../_common/upload-area";
import * as R from "ramda";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import contriesList from "iso-3166-1-alpha-2";
import { createRelocationDeclaration, updateRelocationDeclaration, fetchLifeEvents } from "../../../../../../actions/events-api";
import { RegexFields } from "../../../../../../constants/utils/regexFields";
import { DateWithModal } from "../../../../../../_common/dateWithModal";
import RelocationDeclaration from "../../../../../../constants/models/events/relocationDeclaration";
import Address from "../../../../../../constants/models/address";
import * as loadings from "../../../../../../constants/loadings/relocationDeclaration";
import { PostalCityInput } from "../../../../../../_common/postalCityInput";

import appartement from "../../../../../../assets/images/svg/090-flats.svg";
import maison from "../../../../../../assets/images/svg/069-home.svg";
import palace from "../../../../../../assets/images/svg/093-palace.svg";
import hotel from "../../../../../../assets/images/svg/087-hotel.svg";
import peniche from "../../../../../../assets/images/svg/091-house-2.svg";
import divers from "../../../../../../assets/images/svg/092-camping-tent.svg";
import residenceSenior from "../../../../../../assets/images/svg/147-senior-residence.svg";


export const Step1 = ({ relocatedUser, relocationDeclaration, isLoading, setOnboardingStep, getDeclaration }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	registerLocale("fr", fr);
	const dispatch = useDispatch();

	const identForm = useRef(null);
	const [identFields, setIdentFields] = useState(new RelocationDeclaration(relocationDeclaration));

	const [wasValidated, setWasValidated] = useState(false);

	const addressContract = { owner: 1, tenant: 2, other: 3 };
	const addressType = { appartement: 1, house: 2, castle: 3, hotel: 4, boat: 5, camp: 6, seniorResidence: 7 };

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	useEffect(() => {
		if (!R.isNil(identFields.newAddress?.city)) {
			setIdentFields({ ...identFields, sameArea: identFields.newAddress?.city == identFields.oldAddress?.city });
		}
		if (!R.isNil(identFields.newAddress?.postalCode)) {
			setIdentFields({ ...identFields, sameArea: identFields.newAddress?.postalCode == identFields.oldAddress?.postalCode });
		}
	}, [identFields?.newAddress]);

	return (
		<article className="view-calc pt-3 mb-auto">
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center">
					<h1 className="text-primary font-weight-bolder mt-2 mb-3">Déclarer un déménagement</h1>
				</header>
			</div>
			<div className="auto-view scroll-auto py-4 pb-lg-0">
				<div className="container-fluid">
					<section className="block mb-gutter">
						{/* <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-0">téléchargement obligatoire</h4> */}
						<form className="flex-column py-sm g-sm-3" noValidate ref={identForm}>
							<div className="flex-column gx-2">
								<div className="block mb-3">
									<h5 className="h5 text-uppercase font-weight-bolder mb-2 sr-only" htmlFor="generalinfo">
										Informations générales
									</h5>
									<div className="form-row">
										<div className="col-12 form-row">
											<div className="form-group col-12 col-md-6 col-xl">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"Nom"}>
													Nom *
												</label>
												<input
													required
													type="text"
													className="form-control"
													id={"Nom"}
													onChange={(e) => {
														setIdentFields({ ...identFields, lastName: e.target.value });
													}}
													value={identFields.lastName}
													pattern={RegexFields.nameWithoutNumbers}
												/>
											</div>
											<div className="form-group col-12 col-md-6 col-xl">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"Prenom"}>
													Prénom *
												</label>
												<input
													required
													type="text"
													className="form-control"
													id={"Prenom"}
													onChange={(e) => {
														setIdentFields({ ...identFields, firstName: e.target.value });
													}}
													value={identFields.firstName}
													pattern={RegexFields.nameWithoutNumbers}
												/>
											</div>
											<div className="form-group col-12 col-md-6 col-xl">
												<label className="h6 font-weight-bolder my-auto" htmlFor="Téléphone">
													Téléphone
												</label>
												<input
													type="tel"
													className="form-control"
													id="Téléphone"
													placeholder="00 00 00 00 00"
													defaultValue={identFields.phone}
													onChange={(event) => {
														setIdentFields({ ...identFields, phone: event.target.value });
													}}
													pattern={RegexFields.frenchPhoneNumber}
												/>
											</div>
											<div className="form-group col-12 col-md-6 col-xl">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"Email"}>
													Email
												</label>
												<input
													required
													type="email"
													className="form-control"
													id={"Email"}
													onChange={(e) => {
														setIdentFields({ ...identFields, email: e.target.value });
													}}
													value={identFields.email}
													pattern={RegexFields.email}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="block mb-3">
									<h5 className="h5 text-uppercase font-weight-bolder mb-2" htmlFor="lieudeces">
										Adresse actuelle
									</h5>
									<div className="form-row">
										<div className="form-group col-12 col-md-6">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Adresse">
												Adresse *
											</label>
											<input
												required
												type="text"
												className="form-control"
												id="Adresse"
												value={identFields.oldAddress.addressLine1}
												onChange={(event) => {
													setIdentFields({ ...identFields, oldAddress: { ...identFields.oldAddress, addressLine1: event.target.value } });
												}}
											/>
										</div>
										<PostalCityInput
											postalCode={identFields.oldAddress.postalCode}
											city={identFields.oldAddress.city}
											onChange={(updatedAddress) => setIdentFields({ ...identFields, oldAddress: { ...identFields.oldAddress, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
											hasWrapper={false}
											country={identFields.oldAddress.country}
											customClasses={{ city: "form-group col-12 col-sm", postalCode: "form-group col-12 col-sm" }}
										/>
										{/* <div className="form-group col-12 col-sm">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Postal">
												Code Postal *
											</label>
											{identFields.country === null || identFields.country === "FR" || identFields.country === "GF" || identFields.country === "PF" || identFields.country === "TF" ? (
												<input
													required
													type="text"
													className="form-control"
													id="Postal"
													value={identFields.oldAddress.postalCode}
													onChange={(event) => {
														setIdentFields({ ...identFields, oldAddress: { ...identFields.oldAddress, postalCode: event.target.value } });
													}}
													pattern={RegexFields.frenchZipCode}
												/>
											) : (
												<input
													required
													type="text"
													className="form-control"
													id="Postal"
													value={identFields.oldAddress.postalCode}
													onChange={(event) => {
														setIdentFields({ ...identFields, oldAddress: { ...identFields.oldAddress, postalCode: event.target.value } });
													}}
												/>
											)}
										</div>
										<div className="col-12 d-xl-none"></div>
										<div className="form-group col-12 col-sm">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Ville">
												Ville *
											</label>
											<input
												required
												type="text"
												className="form-control"
												id="Ville"
												defaultValue={identFields.oldAddress.city}
												onChange={(event) => {
													setIdentFields({ ...identFields, oldAddress: { ...identFields.oldAddress, city: event.target.value } });
												}}
												pattern={RegexFields.nameWithoutNumbers}
											/>
										</div> */}
										<div className="form-group col-12 col-sm">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Pays">
												Pays
											</label>
											<select
												className="custom-select"
												id="naturalite"
												tabIndex={-98}
												value={R.isNil(identFields.oldAddress.country) ? "FR" : identFields.oldAddress?.country}
												onChange={(event) => {
													setIdentFields({ ...identFields, oldAddress: { ...identFields.oldAddress, country: event.target.value } });
												}}>
												{Object.keys(contriesList.getData()).map((country, index) => {
													return (
														<option key={index} value={country}>
															{countries.getName(country, "fr", { select: "official" })}
														</option>
													);
												})}
											</select>
										</div>
									</div>
								</div>
								<div className="block">
									<h5 className="h5 text-uppercase font-weight-bolder mb-2" htmlFor="relocation">
										Nouvelle adresse postale
									</h5>
									<div className="form-row">
										<div className="form-group col-12 col-md-6">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Adresse">
												Adresse *
											</label>
											<input
												required
												type="text"
												className="form-control"
												id="Adresse"
												value={identFields.newAddress.addressLine1}
												onChange={(event) => {
													setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressLine1: event.target.value } });
												}}
											/>
										</div>
										<PostalCityInput
											postalCode={identFields.newAddress.postalCode}
											city={identFields.newAddress.city}
											onChange={(updatedAddress) => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
											hasWrapper={false}
											country={identFields.newAddress.country}
											customClasses={{ city: "form-group col-12 col-sm", postalCode: "form-group col-12 col-sm" }}
										/>
										{/* <div className="form-group col-12 col-sm">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Postal">
												Code Postal *
											</label>
											{identFields.country === null || identFields.country === "FR" || identFields.country === "GF" || identFields.country === "PF" || identFields.country === "TF" ? (
												<input
													required
													type="text"
													className="form-control"
													id="Postal"
													value={identFields.newAddress.postalCode}
													onChange={(event) => {
														setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, postalCode: event.target.value } });
													}}
													pattern={RegexFields.frenchZipCode}
												/>
											) : (
												<input
													required
													type="text"
													className="form-control"
													id="Postal"
													value={identFields.newAddress.postalCode}
													onChange={(event) => {
														setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, postalCode: event.target.value } });
													}}
												/>
											)}
										</div>
										<div className="col-12 d-xl-none"></div>

										<div className="form-group col-12 col-sm">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Ville">
												Ville *
											</label>
											<input
												required
												type="text"
												className="form-control"
												id="Ville"
												defaultValue={identFields.newAddress.city}
												onChange={(event) => {
													setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, city: event.target.value } });
												}}
												pattern={RegexFields.nameWithoutNumbers}
											/>
										</div> */}
										<div className="form-group col-12 col-sm">
											<label className="h6 font-weight-bolder my-auto" htmlFor="Pays">
												Pays
											</label>
											<select
												className="custom-select"
												id="naturalite"
												tabIndex={-98}
												value={R.isNil(identFields.newAddress.country) ? "FR" : identFields.newAddress?.country}
												onChange={(event) => {
													setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, country: event.target.value } });
												}}>
												{Object.keys(contriesList.getData()).map((country, index) => {
													return (
														<option key={index} value={country}>
															{countries.getName(country, "fr", { select: "official" })}
														</option>
													);
												})}
											</select>
										</div>
									</div>

									<div className={"invalid-feedback alert-danger alert" + (identFields.newAddress.addressContract === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
									<div className="d-block mb-3">
										<h5 className="h5 text-uppercase font-weight-bolder mb-2">type de bien immobilier</h5>
										<div className="form-row">
											<div className={"form-group col col-lg-4 col-xl-2"}>
												<div className={"card card-body text-center picker-card" + (identFields.newAddress.addressType === addressType.appartement ? " active" : "")} onClick={() => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressType: addressType.appartement } })}>
													<img className="img-fluid mx-auto my-3 mb-2 h-6" src={appartement} alt="appartement" />
													<h2 className="h6 font-weight-bolder text-uppercase mb-auto">appartement</h2>
												</div>
											</div>
											<div className={"form-group col col-lg-4 col-xl-2"}>
												<div className={"card card-body text-center picker-card" + (identFields.newAddress.addressType === addressType.house ? " active" : "")} onClick={() => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressType: addressType.house } })}>
													<img className="img-fluid mx-auto my-3 mb-2 h-6" src={maison} alt="maison" />
													<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Maison</h2>
												</div>
											</div>
											{/* <div className={"form-group col col-lg-4 col-xl-2"}>
												<div className={"card card-body text-center picker-card" + (identFields.newAddress.addressType === addressType.castle ? " active" : "")} onClick={() => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressType: addressType.castle } })}>
													<img className="img-fluid mx-auto my-3 mb-2 h-6" src={palace} alt="palace" />
													<h2 className="h6 font-weight-bolder text-uppercase mb-auto">château</h2>
												</div>
											</div> */}
											<div className={"form-group col col-lg-4 col-xl-2"}>
												<div className={"card card-body text-center picker-card" + (identFields.newAddress.addressType === addressType.seniorResidence ? " active" : "")} onClick={() => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressType: addressType.seniorResidence } })}>
													<img className="img-fluid mx-auto my-3 mb-2 h-6" src={residenceSenior} alt="senior residence" />
													<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Résidence Senior</h2>
												</div>
											</div>
											<div className={"form-group col col-lg-4 col-xl-2"}>
												<div className={"card card-body text-center picker-card" + (identFields.newAddress.addressType === addressType.hotel ? " active" : "")} onClick={() => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressType: addressType.hotel } })}>
													<img className="img-fluid mx-auto my-3 mb-2 h-6" src={hotel} alt="hotel" />
													<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Hôtel</h2>
												</div>
											</div>
											<div className={"form-group col col-lg-4 col-xl-2"}>
												<div className={"card card-body text-center picker-card" + (identFields.newAddress.addressType === addressType.boat ? " active" : "")} onClick={() => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressType: addressType.boat } })}>
													<img className="img-fluid mx-auto my-3 mb-2 h-6" src={peniche} alt="peniche" />
													<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Péniche</h2>
												</div>
											</div>
											<div className={"form-group col col-lg-4 col-xl-2"}>
												<div
													className={"card card-body text-center picker-card" + (identFields.newAddress.addressType === addressType.camp || identFields.newAddress.addressType === addressType.castle ? " active" : "")}
													onClick={() => setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressType: addressType.camp } })}>
													<img className="img-fluid mx-auto my-3 mb-2 h-6" src={divers} alt="divers" />
													<h2 className="h6 font-weight-bolder text-uppercase mb-auto">divers</h2>
													{/* <p className="small o-50 mt-0 mb-auto lh-copy">Château, péniche, ...</p> */}
												</div>
											</div>
											<div className={"invalid-feedback alert-danger alert" + (identFields.newAddress.addressType === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
										</div>
									</div>
									<h5 className="h5 text-uppercase font-weight-bolder mb-2">SITUATION APRÈS LE DÉMÉNAGEMENT</h5>
									<div className="form-inline mb-4">
										<div className="custom-control custom-radio custom-control-inline mr-6">
											<input
												type="radio"
												id="Propriétaire"
												name="bientype"
												className="custom-control-input"
												checked={identFields.newAddress?.addressContract == addressContract.owner}
												onClick={() => {
													setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressContract: addressContract.owner } });
												}}
											/>
											<label className="custom-control-label" htmlFor="Propriétaire">
												Propriétaire
											</label>
										</div>
										<div className="custom-control custom-radio custom-control-inline mr-6">
											<input
												type="radio"
												id="Locataire"
												name="bientype"
												className="custom-control-input"
												checked={identFields.newAddress?.addressContract == addressContract.tenant}
												onClick={() => {
													setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressContract: addressContract.tenant } });
												}}
											/>
											<label className="custom-control-label" htmlFor="Locataire">
												Locataire
											</label>
										</div>
										<div className="custom-control custom-radio custom-control-inline">
											<input
												type="radio"
												id="Autre"
												name="bientype"
												className="custom-control-input"
												checked={identFields.newAddress?.addressContract == addressContract.other}
												onClick={() => {
													setIdentFields({ ...identFields, newAddress: { ...identFields.newAddress, addressContract: addressContract.other } });
												}}
											/>
											<label className="custom-control-label" htmlFor="Autre">
												Autre
											</label>
										</div>
									</div>
									<div className="form-row">
										<div className="form-group col-12 col-md-4">
											<label className="h5 font-weight-bolder my-auto" htmlFor="isSameArea">
												Où déménagez-vous?
											</label>
											<select
												className="custom-select"
												id="isSameArea"
												tabIndex={-98}
												value={identFields.sameArea}
												onChange={(event) => {
													setIdentFields({ ...identFields, sameArea: event.target.value });
												}}>
												<option value={false}>Dans une autre commune</option>
												<option value={true}>Dans la même commune</option>
											</select>
										</div>
										<div className="form-group col-12 col-md-4">
											<label className="h5 font-weight-bolder my-auto" htmlFor="reason">
												Raison du déménagement?
											</label>
											<select
												className="custom-select"
												id="reason"
												tabIndex={-98}
												value={identFields.reason}
												onChange={(event) => {
													setIdentFields({ ...identFields, reason: event.target.value });
												}}>
												<option value={0}>Motif personnel</option>
												<option value={1}>Motif professionnel</option>
											</select>
										</div>
										<div className="form-group col-12 col-md-4">
											<label className="h6 font-weight-bolder my-auto" htmlFor={"effectiveMovingDate"}>
												Date d'effet du déménagement *
											</label>
											<DateWithModal selectedDate={identFields.effectiveMovingDate} setSelectedDate={(d) => setIdentFields({ ...identFields, effectiveMovingDate: d })} isRequired={true} noMaxDate={true} />
										</div>
									</div>
								</div>
								<div className="block mt-2">
									<div className="card alert-primary text-body my-2 mt-sm-0 mb-sm-auto">
										<div className="card-body d-flex align-items-start">
											<i className="eva eva-alert-triangle text-primary mr-2 h3 mt-n1"></i>
											<div className="flex-grow-1">
												<h1 className="small font-weight-bolder text-primary text-uppercase">Attention</h1>
												<p className="lh-copy mb-1">En passant à l'étape suivante, veuillez être certain de déménager à la date renseignée car vous ne pourrez pas la modifier après validation.</p>

												<div className="form-group mt-3">
													<div className="custom-control custom-switch">
														<input type="checkbox" className="custom-control-input" id="customSwitch1" required defaultChecked={relocationDeclaration.onBoardingStep > 1} />
														<label className="custom-control-label" htmlFor="customSwitch1">
															Je déclare sur l'honneur que les informations ci-dessus sont véridiques
														</label>
													</div>
													<div className={"invalid-feedback"} id="customSwitch1InvalidFeedback">
														Veuillez confirmer la véracité des informations fournies.
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
				</div>
				<div className="container-fluid">
					<footer className="d-block mt-auto mb-sm text-right w-100">
						<button type="button" className="btn btn-faded px-md-gutter mr-3" aria-label="close" data-dismiss="modal">
							Fermer
						</button>
						{isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) || isLoading.includes(loadings.CREATING_RELOCATION_DECLARATION) ? (
							<button type="button" className="btn btn-info loading-btn px-md-gutter px-4 show">
								Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						) : (
							<button
								type="button"
								className="btn btn-info px-md-gutter px-4"
								onClick={async (event) => {
									event.preventDefault();
									if (R.isNil(identFields.effectiveMovingDate) || identFields.effectiveMovingDate < new Date()) {
										document.getElementById("date-modal").setCustomValidity("Invalid value");
									} else {
										document.getElementById("date-modal").setCustomValidity("");
									}

									identForm.current.classList.add("was-validated");
									if (!document.getElementById("customSwitch1").checked) {
										document.getElementById("customSwitch1InvalidFeedback").classList.add("d-block");
									}

									if (identForm.current.checkValidity()) {
										if (R.isNil(identFields.id) || identFields.id === "") {
											dispatch(createRelocationDeclaration(relocatedUser.id, { ...identFields, movingType: identFields.newAddress.addressContract, allocations: identFields.allocations, professionalSituation: identFields.professionalSituation.join(", "), onBoardingStep: 2 })).then(() => {
												getDeclaration();
												setOnboardingStep(2);
												dispatch(fetchLifeEvents(relocatedUser.id));
											});
										} else {
											dispatch(updateRelocationDeclaration(relocatedUser.id, { ...identFields, movingType: identFields.newAddress.addressContract })).then(() => {
												getDeclaration();
												setOnboardingStep(2);
											});
										}
									}
								}}>
								Passer à l'étape suivante
							</button>
						)}
					</footer>
				</div>
			</div>
		</article>
	);
};
